import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check, X } from "lucide-react";
import { useI18n } from "../../i18n/I18nProvider";
import { getCompareLightspeed } from "../../i18n/content";

export default function CompareCTA() {
  const { t, locale } = useI18n();
  const highlights = getCompareLightspeed(locale).slice(0, 5);
  return (
    <section data-testid="compare-cta-section" className="py-24 sm:py-32 bg-oj-deep text-white relative overflow-hidden">
      <div className="absolute inset-0 noise opacity-30 pointer-events-none" />
      <div className="container-oj relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-400">{t("compare_cta.eyebrow")}</div>
            <h2 className="font-display mt-4 text-balance text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95]">
              {t("compare_cta.h2_a")} <span className="bg-oj-brand text-oj-deep px-3 rounded-md">{t("compare_cta.h2_b")}</span><br />
              {t("compare_cta.h2_c")}
            </h2>
            <p className="mt-5 max-w-md text-lg text-zinc-300 leading-relaxed">
              {t("compare_cta.body")}
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to="/compare/lightspeed"
                data-testid="compare-cta-button"
                className="inline-flex items-center gap-1.5 bg-oj-brand text-oj-deep font-semibold px-6 py-3.5 rounded-md hover:bg-[#6FBDB9] transition-opacity"
              >
                {t("compare_cta.cta")} <ArrowUpRight className="size-4" />
              </Link>
              <Link
                to="/#demo"
                className="inline-flex items-center gap-1.5 border border-white/20 bg-white/5 text-white font-semibold px-6 py-3.5 rounded-md hover:bg-white/10 transition-colors"
              >
                {t("compare_cta.cta2")}
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-2xl border border-white/10 bg-black/20 backdrop-blur-sm overflow-hidden">
              <div className="grid grid-cols-12 px-6 py-4 border-b border-white/10 text-[11px] font-bold uppercase tracking-[0.18em] text-zinc-300">
                <div className="col-span-5">{t("compare_cta.dim")}</div>
                <div className="col-span-4 text-oj-brand">O&#39;javana</div>
                <div className="col-span-3 text-zinc-500">Lightspeed</div>
              </div>
              <ul className="divide-y divide-white/10">
                {highlights.map((row, idx) => (
                  <li key={idx} className="grid grid-cols-12 px-6 py-4 items-center" data-testid={`compare-row-${idx}`}>
                    <div className="col-span-5 text-sm text-zinc-200">{row.dim}</div>
                    <div className="col-span-4 text-sm font-semibold text-white flex items-start gap-2">
                      <Check className="size-4 mt-0.5 shrink-0 text-oj-brand" /> {row.oj}
                    </div>
                    <div className="col-span-3 text-sm text-zinc-400 flex items-start gap-2">
                      <X className="size-4 mt-0.5 shrink-0 text-zinc-500" /> {row.ls}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
